import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'react-multi-carousel/lib/styles.css';
import Button from '../../shared/Button/Button'
import useAllSitePage from '../../hooks/useAllSitePage';
import { useGlobalData } from '../../context/globalDataContxt';
import '../../helpers/font-awesome';
import './NoveltyCard.scss';

function NoveltyCard({ noveltie }) {

  const pagesPath = useAllSitePage()
  
  const {
    allSitePage: matchPages
  } = pagesPath

  const { configPucc } = useGlobalData();
  
  return (
    <div
      className={`mb-4 ${ noveltie.destacado
        ? 'highlighted'
        : ''
      }`}
      key={`noveltiesNodesId-${noveltie.novelty.id}`}
    >
      <div className={`news-card h-100 d-flex rounded shadow overflow-hidden position-relative flex-column`}>
        <div
          className={`news-image`}
          style={noveltie.novelty?.thumbnail?.url
            ? {
              backgroundImage: `url(${noveltie.novelty?.thumbnail.url})`
            }
            : {
              backgroundImage: `url(${configPucc.noveltiesFeedConfig.noveltyImgDefaul?.url})`
            }
          }
          role="img"
          alt={noveltie.novelty?.thumbnailName || ''}
        ></div>

        <div className="news-info flex-grow-1 p-4 d-flex flex-column">
          <div className='news-date'>
            <small>
              {moment(noveltie.novelty?.date)
                .locale('es')
                .format('DD-MM-YYYY')}
            </small>
          </div>

          <h5 className="news-title">
            {noveltie.title || noveltie.novelty?.title}
          </h5>

          <div className="noticies-markdown">
            <p>
              {noveltie.novelty?.summary
                ? noveltie.novelty.summary
                : null}
            </p>
          </div>
          
          <Button
            classButton={`text-left px-4 mb-0 rounded-0`}
            button={noveltie}
            customButton={{ 
              variant: noveltie.destacado? 'secondary' :'secondary_outline' , 
              size: "", 
              shape: 'pill' 
            }}
            classContainer="d-flex mt-auto"
            matchPages={matchPages.nodes}
          />
        </div>
      </div>
    </div>
  )
}

export default NoveltyCard;

NoveltyCard.propTypes = {
  noveltie: PropTypes.object.isRequired,
};